import classNames from 'classnames';
import { Link } from 'react-router-dom';

import ArrowBackIcon from '@/assets/icons/arrow-back.svg?react';

import styles from './PageTitle.module.scss';

export type RightLinkColor = 'primary' | 'gray';
export type PageTitleVariant = 'default' | 'mypage-profile';

export interface Props {
  title: string | React.ReactNode;
  backLinkLabel?: string | null;
  backLinkUrl?: string;
  onBackLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  rightLinkLabel?: string | null;
  rightLinkUrl?: string;
  onRightLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  rightLinkColor?: RightLinkColor;
  variant?: PageTitleVariant;
}

const PageTitle: React.FC<Props> = ({
  title,
  backLinkLabel,
  backLinkUrl,
  onBackLinkClick,
  rightLinkLabel,
  rightLinkUrl,
  onRightLinkClick,
  rightLinkColor = 'primary',
  variant = 'default',
}) => (
  <div
    className={classNames(styles.wrapper, {
      [styles.wrapperMypageProfile]: variant === 'mypage-profile',
    })}
  >
    <div
      className={classNames(
        styles.inner,
        backLinkLabel ? styles.innerWithLabel : styles.innerWithoutLabel,
        { [styles.innerMypageProfile]: variant === 'mypage-profile' },
      )}
    >
      <div
        className={classNames(styles.left, {
          [styles.leftMypageProfile]: variant === 'mypage-profile',
        })}
      >
        {backLinkLabel && (
          <Link
            to={backLinkUrl || ''}
            className={styles.backLink}
            onClick={onBackLinkClick}
          >
            <ArrowBackIcon className={styles.backIcon} />
            <span>{backLinkLabel}</span>
          </Link>
        )}
        <h1
          className={classNames(styles.title, {
            [styles.titleMypageProfile]: variant === 'mypage-profile',
          })}
        >
          {title}
        </h1>
      </div>
      {rightLinkLabel && (
        <div
          className={classNames({
            [styles.rightMypageProfile]: variant === 'mypage-profile',
          })}
        >
          <Link
            to={rightLinkUrl || ''}
            className={classNames(
              styles.rightLink,
              rightLinkColor === 'primary'
                ? styles.rightLinkPrimary
                : styles.rightLinkGray,
              { [styles.rightLinkMypageProfile]: variant === 'mypage-profile' },
            )}
            onClick={onRightLinkClick}
          >
            {rightLinkLabel}
          </Link>
        </div>
      )}
    </div>
  </div>
);

export default PageTitle;
